import axios from 'axios'
import { useEffect, useState } from 'react'
import * as TypIcons from 'react-icons/ti'
import { useParams } from 'react-router'
import { useNavigate } from 'react-router-dom'
import {
  Assign,
  Assign2,
  ContainerPage2,
  CxAssign,
  DataAudit,
  RelForm,
  RelFormFormulario6,
  TabelaPadraoRelatorio,
  TabelaPadraoRelatorio2,
  TitleOfPageRel,
  TitlePageRel,
  TitlePageRel1,
  TitlePageRel2
} from '../../Components/Main'
import '../../styles/pages/MenuDireito/relatorioAudit.css'
function RelatorioAudit() {
  const history = useNavigate()
  let id = useParams()
  const [auditoria, setAuditoria] = useState([])
  const [audData, setaudData] = useState('')
  const [locDescricao, setlocDescricao] = useState('')
  const [audNota, setaudNota] = useState('')
  const [audResponsavelLocal, setaudResponsavelLocal] = useState('')
  const [audEmailResponsavel, setaudEmailResponsavel] = useState('')
  const [pesNome, setpesNome] = useState('')
  const [audTelefoneResponsavel, setaudTelefoneResponsavel] = useState('')
  const [audAssinatura, setaudAssinatura] = useState('')
  const [audAssinaturaCliente, setaudAssinaturaCliente] = useState('')
  const [audcodigoGUID, setAudcodigoGUID] = useState('')
  console.log(audData)
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/auditoria/' +
        id['IdRetornoAuditoria']
      )
      .then(response => {
        setAuditoria(response.data)
        setaudData(response.data[0].audFinalizadoEm)
        setlocDescricao(response.data[0].locDescricao)
        setaudNota(response.data[0].audNota)
        setaudAssinatura(response.data[0].audURLAssinaturaAuditor)
        setaudResponsavelLocal(response.data[0].audResponsavelLocal)
        setpesNome(response.data[0].pesNome)
        setaudEmailResponsavel(response.data[0].audEmailResponsavel)
        setaudTelefoneResponsavel(response.data[0].audTelefoneResponsavel)
        setaudAssinaturaCliente(response.data[0].audURLAssinaturaResponsavel)
        setAudcodigoGUID(response.data[0].audcodigoGUID)
        console.log(response)
      })
  }, [])
  const areas = auditoria.map(q => q.rtiSubArea)
  return (
    <>
      <ContainerPage2>
        <button
          className="btnReturnRel"
          type="button"
          onClick={() => history(-1)}
        >
          <TypIcons.TiArrowBackOutline />
        </button>
        {/* href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?id=${id['IdRetornoAuditoria']}`} */}
        <a
          href={`http://ws.hitperformance.com.br/Cozinha/RelatorioAuditoria?guid=${audcodigoGUID}`}
          target={'_blank'}
        >
          <button className="CapImg">
            <div
              style={{
                'background-color': 'transparent',
                color: '#077e1a',
                width: '100%',
                height: '100%',
                display: 'flex',
                'font-size': '25px',
                'justify-content': 'center',
                'align-items': 'center'
              }}
            >
              <i className="far fa-file-pdf"></i>
            </div>
          </button>
        </a>
        <TitleOfPageRel>
          <div
            className="logoRelatorioRel"
            style={{ width: '200px', height: '80px' }}
          />
          <TitlePageRel style={{ height: '80px' }}>
            RELATÓRIO DE AUDITORIA
          </TitlePageRel>
        </TitleOfPageRel>
        <TitlePageRel1>
          CLIENTE: {sessionStorage.uniRazaoSocial}
          <DataAudit>Data da Auditoria: {audData.substring(0, 10)}</DataAudit>
        </TitlePageRel1>

        <RelForm>
          <div className="relFormFormulario1">
            <label className="TtlInfoRel1">
              LOCAL AUDITADO
              <input disabled className="InfoRel1" value={locDescricao} />
            </label>

            <label className="TtlInfoRel2">
              E-MAIL
              <input
                disabled
                className="InfoRel2"
                value={audEmailResponsavel}
              />
            </label>

            <label className="TtlInfoRel3">
              AUDITOR
              <input disabled className="InfoRel3" value={pesNome} />
            </label>
          </div>
          <div className="relFormFormulario2">
            <label className="TtlInfoRel4">
              RESPONSÁVEL
              <input
                disabled
                className="InfoRel4"
                value={audResponsavelLocal}
              />
            </label>

            <label className="TtlInfoRel5">
              TELEFONE
              <input
                disabled
                className="InfoRel5"
                value={audTelefoneResponsavel}
              />
            </label>

            <label className="TtlInfoRel6">
              HORA
              <input
                disabled
                className="InfoRel6"
                value={audData.substring(11, 16)}
              />
            </label>
          </div>
          <div className="relFormFormulario3">
            <div className="FuncaoResultadoRel1">Nota:</div>
            <div className="FuncaoResultadoRel2">{audNota}</div>
          </div>
          <div className="relFormFormulario4">
            <table className="tabelaNotas">
              <tbody>
                <tr>
                  <td className="TdRelPTS">PONTOS</td>
                  <td className="TdRelPTS" colSpan={2}>
                    CLASSIFICAÇÂO SANITÁRIA
                  </td>
                </tr>
                <tr>
                  <td className="TdRelPTS">10,0 a 8,0</td>
                  <td className="TdRelA">A</td>
                  <td className="TdRel1">BOM</td>
                </tr>
                <tr>
                  <td className="TdRelPTS">7,9 a 6,0</td>
                  <td className="TdRelB">B</td>
                  <td className="TdRel1">REGULAR</td>
                </tr>
                <tr>
                  <td className="TdRelPTS">5,9 a 3,0</td>
                  <td className="TdRelC">C</td>
                  <td className="TdRel1">RUIM</td>
                </tr>
                <tr>
                  <td className="TdRelPTS">2,9 a 0</td>
                  <td className="TdRelD">PENDENTE</td>
                  <td className="TdRel1">INACEITÀVEL</td>
                </tr>
              </tbody>
            </table>
          </div>
        </RelForm>
        <RelFormFormulario6>
          Este relatório de Auditoria Sanitária realizado pela Cozinha e Saúde
          Segurança dos Alimentos nas áreas de produção, manipulação e
          armazenamento de alimentos têm o objetivo de identificar as não
          conformidades encontradas, baseadas nas Leis e Normas Sanitárias
          Vigentes. Independente da nota final da Auditoria Sanitária,
          avaliações consideradas GRAVES ou GRAVÍSSIMAS expõe o estabelecimento
          a interdições sanitárias, gerando risco à saúde dos comensais. Segue
          abaixo as considerações:
        </RelFormFormulario6>
        <TabelaPadraoRelatorio>
          <table>
            {areas
              .filter((q, idx) => areas.indexOf(q) === idx)
              .map(area => (
                <tr>
                  <td>{area}</td>
                  <td>
                    {auditoria
                      .filter(val => {
                        if (val.rtiSubArea === area) {
                          return val
                        }
                      })
                      .map(audit => (
                        <tr> - {audit.rtiSubAreaRelato}</tr>
                      ))}
                  </td>
                </tr>
              ))}
          </table>
        </TabelaPadraoRelatorio>
        <TitlePageRel2>OBSERVAÇÕES DE AUDITORIA</TitlePageRel2>
        <TabelaPadraoRelatorio2>
          <table>
            {auditoria.map(audit => (
              <tr>
                <td>
                  {audit.rtiCaminhoWeb ? (
                    <div
                      style={{
                        background: `url(${audit.rtiCaminhoWeb}) no-repeat center/cover`,
                        width: '150px',
                        height: '150px'
                      }}
                    ></div>
                  ) : (
                    // <img
                    //   src={audit.rtiCaminhoWeb}
                    //   alt=""
                    //   width={300}
                    //   height={300}
                    // />
                    ''
                  )}
                  {/* <img src={audit.rtiCaminhoWeb} alt="" width={300} height={300}/> */}
                </td>
                <td>
                  <tr>Severidade: {audit.rtiNotaTexto}</tr>
                  <tr>{audit.rtiNotaDescricao}</tr>
                  <tr>{audit.rtiSubArea}</tr>
                </td>
              </tr>
            ))}
          </table>
        </TabelaPadraoRelatorio2>
        <p style={{ position: 'relative', pageBreakAfter: 'always' }}></p>
        <CxAssign>
          <Assign>
            {audAssinatura ? (
              <div
                style={{
                  background: `url(${audAssinatura}) no-repeat center/cover`,
                  width: '150px',
                  height: '150px'
                }}
              ></div>
            ) : (
              // <img alt="" src={audAssinatura} width={150} height={150} />
              ''
            )}
            ____________________ <br />
            Cozinha e Saúde
          </Assign>
          <Assign2>
            {audAssinaturaCliente ? (
              <img alt="" src={audAssinaturaCliente} width={150} height={150} />
            ) : (
              ''
            )}
            ____________________
            <br /> Cliente
          </Assign2>
        </CxAssign>
      </ContainerPage2>
    </>
  )
}

export default RelatorioAudit
